export const UI_NAME = 'ui-progress';

export const KIND_DEFAULT = 'default';
export const KIND_PRIMARY = 'primary';
export const KIND_SECONDARY = 'secondary';
export const KIND_SUCCESS = 'success';
export const KIND_INFO = 'info';
export const KIND_WARNING = 'warning';
export const KIND_DANGER = 'danger';

export const KINDS = [
  KIND_DEFAULT,
  KIND_PRIMARY,
  KIND_SECONDARY,
  KIND_SUCCESS,
  KIND_INFO,
  KIND_WARNING,
  KIND_DANGER
];
